module.exports = __webpack_public_path__ + "img/c1.a38c8d30.png";